<template>
    <div class="w-full p-2 flex gap-2 items-center">
        <div v-for="index in [0, 1, 2]" :key="index">
            <BadgePill class="" color="gray" v-if="question.options['label_' + index]">
                <span>
                    <LatexMaybe
                        :model-value="question.options['label_' + index]"
                        :is-latex="question.is_latex_answers"
                    />
                </span>
                <span>&nbsp;=&nbsp;</span>
                <span>{{ question.options['value_' + index] }}</span>
            </BadgePill>
        </div>
    </div>
    <div v-if="question.options.order_matters" class="flex gap-2 text-gray-400">
        <IconInfoCircleFilled class="h-4 w-4" /><span
            >{{ $t('messages.tolerance') }}: {{ question.options.tolerance }}</span
        >
    </div>
</template>
<script>
import { IconInfoCircleFilled } from '@tabler/icons-vue';
import BadgePill from '@/components/BadgePill.vue';
import LatexMaybe from '@/components/LatexMaybe.vue';

export default {
    name: 'QuestionMathXyzAnswersViewOnly',
    components: {
        LatexMaybe,
        BadgePill,
        IconInfoCircleFilled,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
